function addZeroClass(wrapper) {
  const inventory = wrapper.querySelectorAll('.inventory-stock');
  inventory.forEach(stockEl => {
    const quantityText = stockEl.querySelector('.inventory-quantity-status-success span')?.textContent || '';
  
    const match = quantityText.match(/(\d+)/);
    const quantity = match ? parseInt(match[1], 10) : null;
  
    if (quantity === 0) {
      const icons = stockEl.querySelectorAll('.inventory-icon-success, .inventory-quantity-status-success');
      icons.forEach(ele => {
        if (!ele.classList.contains("inventory-zero")) {
          ele.classList.add('inventory-zero');
        }
      });
    }
  });
}

setTimeout(()=>{
  const wrapper = document.querySelector("#customerPortalIframe").contentDocument;

  if (wrapper?.body) {
    addZeroClass(wrapper);

    const modalObserver = new MutationObserver(function (mutations, observer) {
      for (const mutation of mutations) {
        if (mutation.type === "attributes" && mutation.attributeName === "data-lock-scrolling") {
          addZeroClass(wrapper);
        }
      }
    });

    modalObserver.observe(wrapper.body, { attributes: true });
  }
},6000)

function handleInventoryStatus(rootDoc) {
  if (!rootDoc) return;

  const inventoryList = rootDoc.querySelectorAll('.inventory-stock');

  inventoryList.forEach((stockEl) => {
    const statusEl = stockEl.querySelector('.inventory-quantity-status-success');
    if (!statusEl) return;

    const spanEl = statusEl.querySelector('span') || statusEl;
    const text = spanEl.textContent || '';
    const iconEl = stockEl.querySelector('.inventory-icon-success svg');

    const isNegative = /(?:-|–|—|−)\s*\d+/.test(text);

    const match = text.match(/\b0\b/);
    const isZero = !isNegative && match !== null;

    if (isNegative) {
      statusEl.style.setProperty('color', '#d82c0d', 'important');
      spanEl.style.setProperty('color', '#d82c0d', 'important');
      if (iconEl) {
        iconEl.style.setProperty('fill', '#d82c0d', 'important');
        iconEl.style.setProperty('color', '#d82c0d', 'important');
      }
    } else {
      statusEl.style.removeProperty('color');
      spanEl.style.removeProperty('color');
      if (iconEl) {
        iconEl.style.removeProperty('fill');
        iconEl.style.removeProperty('color');
      }
    }

    if (isZero) {
      const icons = stockEl.querySelectorAll('.inventory-icon-success, .inventory-quantity-status-success');
      icons.forEach((ele) => {
        if (!ele.classList.contains('inventory-zero')) {
          ele.classList.add('inventory-zero');
        }
      });
    }
  });
}

function initPortalObserver() {
  const iframe = document.querySelector('#customerPortalIframe');

  if (!iframe) {
    setTimeout(initPortalObserver, 500);
    return;
  }

  function attachObserver() {
    try {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!iframeDoc || !iframeDoc.body) return;

      handleInventoryStatus(iframeDoc);

      const observer = new MutationObserver(() => {
        handleInventoryStatus(iframeDoc);
      });

      observer.observe(iframeDoc.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
      });
    } catch (e) {
      console.warn('Cannot access iframe content:', e);
    }
  }

  if (iframe.contentDocument?.readyState === 'complete') {
    attachObserver();
  }
  iframe.addEventListener('load', attachObserver);

  setTimeout(attachObserver, 2000);
  setTimeout(attachObserver, 4000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPortalObserver);
} else {
  initPortalObserver();
}
